"use client";

import PropTypes from "prop-types";

import Container from "components/grid/container";
import SignupBoxes from "components/signup-boxes";
import SignupTabWrapper from "components/signup-tab-wrapper";

import styles from "./styles.module.css";

const SignupScreen = ({ signupType }) => {
  return (
    <>
      <div id="content-wrapper">
        <Container>
          <div className={styles.wrapper}>
            <div className={styles.actionWrap}>
              <SignupTabWrapper signupType={signupType} />
            </div>
            <div className={styles.boxWrap}>
              <h1 className={styles.title}>Neden Üye Olmalıyım?</h1>
              <SignupBoxes signupType={signupType} />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

SignupScreen.propTypes = {
  signupType: PropTypes.string,
};

export default SignupScreen;
